// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__n55Y_","toggleWrap":"styles_toggleWrap__1deCC","content":"styles_content__B4dQc","selectAreaCode":"styles_selectAreaCode__2Te-x"};